//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters, mapMutations } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";

export default {
    components: {
        AQButton
    },
    data() {
        return {
            counter: 30,
            fileName: "",
            retryDisable: false,
            allowDownload: false,
            noPermission: false,
            downloadBtnLabel: this.$t("exportReports.retryDlBtn")
        };
    },
    computed: {
        ...mapGetters("main", ["getInfoApp"]),
        ...mapGetters("reports", ["getDataToExport"]),
        getYear() {
            return new Date().getFullYear();
        }
    },
    watch: {
        noPermission(newValue) {
            if (newValue) {
                this.$router.push("/accessDenied");
            }
        }
    },
    created() {
        localStorage.removeItem("isFromReportsExport");
        this.fileName = this.$route.query.fileName;
        const { fileName: currentFile, response } = this.getDataToExport;
        if (currentFile === this.fileName) {
            this.downloadData(response);
            this.setDataToExport();
        } else {
            this.createDlLink();
        }
    },
    methods: {
        ...mapActions("reports", ["actDownloadExportedFile"]),
        ...mapMutations("reports", ["setDataToExport"]),
        createDlLink() {
            this.actDownloadExportedFile({ fileName: this.fileName, type: this.$route.query.type }).then(
                response => {
                    this.downloadData(response);
                },
                error => {
                    const errorResponse = JSON.parse(JSON.stringify(error));
                    this.allowDownload = !(errorResponse.response && errorResponse.response.status === 401);
                    this.noPermission = !this.allowDownload;
                }
            );
        },
        downloadData(response) {
            const blob = new Blob([response.data], {
                type: response.headers["content-type"],
                responseType: "arraybuffer"
            });
            const downloadUrl = URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = this.fileName;
            document.body.appendChild(anchor);
            anchor.click();
            this.allowDownload = true;
            this.noPermission = false;
            setTimeout(() => {
                document.body.removeChild(anchor);
                window.URL.revokeObjectURL(downloadUrl);
            }, 0);
        },
        downloadCsv() {
            const updateCounter = () => {
                if (this.counter > 1) {
                    this.counter--;
                    this.downloadBtnLabel = this.$t("exportReports.downloadBtnLabelCounter", { counter: this.counter });
                } else {
                    // eslint-disable-next-line no-use-before-define
                    clearInterval(nIntervId);
                    this.counter = 30;
                    this.downloadBtnLabel = this.$t("exportReports.retryDlBtn30s");
                }
            };
            const nIntervId = setInterval(updateCounter, 1000);
            this.retryDisable = true;
            this.downloadBtnLabel = this.$t("exportReports.retryDlBtn30s");
            this.createDlLink();
            setTimeout(() => {
                this.retryDisable = false;
                this.downloadBtnLabel = this.$t("exportReports.retryDlBtn");
            }, 30000);
        }
    }
};
